import { UpDownTradingPanel } from '../../../../../components/UpDownTradingPanel';

export function UpDownChartBoard(props) {
  return <UpDownTradingPanel {...props} />;
}
